import { DEBUG } from "../Env"

const inquiriesUrl = process.env.REACT_APP_LEAZYAI_CRM_API_INQUIRIES as string
if(DEBUG){
    console.log("inquiriesUrl: ", inquiriesUrl)
}

export interface InquiriesRequest{
    address: string
    email: string
    message: string
    name: string
    phone: string
    subject: string
}

async function inquiries(request: InquiriesRequest){
    // const url = "https://formspree.io/f/myzebowa"
    const formData = new URLSearchParams();
    for (const [key, value] of Object.entries(request)) {
        formData.append(key, value);
    }
    const response = await fetch(inquiriesUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData,
        redirect: "manual" // 设置为manual，不自动跳转
    });
    return "Submit successfully"
    // return postData(inquiriesUrl, request)
}

// Example POST method implementation:
async function postData(url = "", data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
    //   cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    //   credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }


/**
 * Translation-request submissions. These share the general inquiries form, so
 * every request is labelled to make it filterable in the shared inbox:
 * `_subject` sets the actual email subject line, and `service` / `formType`
 * tag the submission body and the Formspree dashboard.
 */
export interface TranslationRequest {
    name: string
    email: string
    languages: string
    deadline: string
    details: string
}

async function translationRequest(request: TranslationRequest) {
    const subject = `Translation Request - ${request.name}`
    const formData = new URLSearchParams()
    formData.append("_subject", subject)   // Formspree uses this as the email subject line
    formData.append("subject", subject)    // and as a body field, matching inquiries()
    formData.append("service", "RB Translation Service")
    formData.append("formType", "translation-request")
    for (const [key, value] of Object.entries(request)) {
        formData.append(key, value)
    }
    // unlike inquiries(), this checks the response: Formspree answers with JSON
    // when asked to, so a failed submit surfaces instead of reporting success
    const response = await fetch(inquiriesUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
        },
        body: formData
    })
    if (!response.ok) {
        throw new Error(`Translation request failed: ${response.status}`)
    }
    return "Submit successfully"
}

export default {
    inquiries,
    translationRequest
}